import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { ConversationType } from '@clientwire/api';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { WireApiService } from '../services';
import { ErrorStore } from './error.store';
type ConversationTypeState = {
  types: ConversationType[];
};

const initialState: ConversationTypeState = {
  types: [],
};

export const ConversationTypeStore = signalStore(
  { providedIn: 'root' },
  withDevtools('conversation-type-store'),
  withState(initialState),
  withMethods((store) => {
    const wireApiService = inject(WireApiService);
    const errorStore = inject(ErrorStore);

    // The dashboard and the conversation list both request the types while initialising, which
    // used to fire two identical requests on every load. Callers that arrive while a request is
    // in flight share it; a call made after it settles fetches again, so refreshing still works.
    let inFlight: Promise<void> | null = null;

    async function fetchConversationTypes(): Promise<void> {
      try {
        const response = await wireApiService.conversationTypesApi.getConversationTypes();
        updateState(store, 'Set ConversationTypes', {
          types: response.conversationTypes,
        });
      } catch (error) {
        try {
          await errorStore.addErrorResponse(error, 'global');
        } catch {
          await errorStore.addErrorResponse({ code: 'error.conversationType.get' }, 'global', false);
          throw error;
        }
      }
    }

    return {
      getConversationTypes(): Promise<void> {
        inFlight ??= fetchConversationTypes().finally(() => {
          inFlight = null;
        });

        return inFlight;
      },

      conversationTypeById(id: string) {
        return store.types().find((type) => type.id === id);
      },

      clearConversationTypes() {
        updateState(store, 'Clear entities', initialState);
      },
    };
  })
);
